import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { ImageSkeleton } from "../../../../components/loading/ImageSkeleton";

interface CreatorMiniCardProps {
  name: string;
  typeName?: string;
  avatarUrl?: string;
  avatarOnly?: boolean;
  onClick: () => void;
}

export function CreatorMiniCard({ name, typeName, avatarUrl, avatarOnly, onClick }: CreatorMiniCardProps) {
  if (avatarOnly) {
    return (
      <Box
        flexShrink={0}
        w="48px"
        h="48px"
        borderRadius="full"
        overflow="hidden"
        bg="transparent.white.05"
        cursor="pointer"
        onClick={onClick}
        _hover={{ opacity: 0.85 }}
      >
        {avatarUrl ? (
          <Image src={avatarUrl} alt={name} w="full" h="full" objectFit="cover" />
        ) : (
          <ImageSkeleton w="full" h="full" borderRadius="full" />
        )}
      </Box>
    );
  }

  return (
    <Box
      flexShrink={0}
      w="100px"
      borderRadius="8px"
      bg="transparent.black.30"
      cursor="pointer"
      onClick={onClick}
      _hover={{ opacity: 0.85 }}
      overflow="hidden"
    >
      <Box w="full" h="100px" overflow="hidden">
        {avatarUrl ? (
          <Image src={avatarUrl} alt={name} w="full" h="full" objectFit="cover" />
        ) : (
          <ImageSkeleton w="full" h="full" />
        )}
      </Box>
      <Flex direction="column" p="6px" gap="1px">
        <Text fontSize="11px" fontFamily="Roboto" fontWeight="500" color="white" noOfLines={1}>
          {name}
        </Text>
        {typeName && (
          <Text fontSize="10px" fontFamily="Roboto" color="neutral.400" noOfLines={1}>
            {typeName}
          </Text>
        )}
      </Flex>
    </Box>
  );
}
